import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { UserPortalContext } from '../../../context/appcontext';
import { getItemChannelBreakdown } from '../../../redux/actions/itemDrillDownActions';
import ChannelBreakdown from '../../../common/components/charts/ChannelBreakdown/ChannelBreakdown';

const ItemChannelBreakdown = ({
	weekFilter,
	category,
	selectedFilter,
	itemNum,
	startDate,
	endDate,
	height,
}) => {
	const dispatch = useDispatch();
	const portalUserContext = React.useContext(UserPortalContext);
	const {
		channelBreakDownData,
		channelBreakDownloading,
		channelBreakDownErrorCode,
		unitsChannelBreakDownData,
		unitsChannelBreakDownLoading,
		unitsChannelBreakDownErrorCode,
	} = useSelector((state) => state.itemDrillDownReducer);
	const selectedView = useSelector(
		(state) => state.appGuideReducer.selectedView
	);

	const urlParams = new URLSearchParams(window.location.search);
	const subCatId = urlParams.get('subCatId');
	const brandId = urlParams.get('brandId');

	React.useEffect(() => {
		if (itemNum) {
			const params = {
				categoryId: '-1',
				period: weekFilter,
				portalUserContext,
				itemNum,
				selectedFilter,
				subCatId,
				brandId,
				startDate,
				endDate,
			};
			dispatch(getItemChannelBreakdown(params));
		}
	}, [
		weekFilter,
		category,
		itemNum,
		subCatId,
		brandId,
		startDate,
		endDate,
		selectedView,
	]);

	const cbData = {
		cbSalesData: channelBreakDownData,
		cbUnitsData: unitsChannelBreakDownData,
		isloading: [channelBreakDownloading, unitsChannelBreakDownLoading],
		isError: [channelBreakDownErrorCode, unitsChannelBreakDownErrorCode],
		summary:
			channelBreakDownData?.summary || unitsChannelBreakDownData?.summary,
	};

	return (
		<ChannelBreakdown
			selectedFilter={selectedFilter}
			data={cbData}
			weekFilter={weekFilter}
			category={category}
			height={height}
			itemDrillDown={true}
		/>
	);
};

ItemChannelBreakdown.propTypes = {
	itemNum: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	weekFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	category: PropTypes.string,
	selectedFilter: PropTypes.string,
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	selectedTab: PropTypes.string,
	height: PropTypes.string,
};

export default ItemChannelBreakdown;
